export const POST_INLINE_WAPP_ID = 'post-post-inline'
